module.exports = __webpack_public_path__ + "static/img_6.ed91d0db.jpg";